import module from '../../shared.module';
import _ from 'lodash';

module.component('friendList', {
  templateUrl: 'app/shared/components/friend-list/friend-list.tpl.html',

  controller: [
    'FriendsService',
    '$stateParams',
    function (FriendsService, $stateParams) {
      var ctrl = this;
      FriendsService.friends.then(function (data) {
        ctrl.friends = data;
      });

      this.isActive = function (friendId) {
        return friendId == $stateParams.friendId;
      };
    },
  ],
});
